import {Component, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {Router} from '@angular/router';

import {ToastsManager} from 'ng6-toastr';
import {HttpParams} from '@angular/common/http';
import {RequestsService} from '../../../../services/requests.service';
import jqxDropDownList = jqwidgets.jqxDropDownList;

export interface PosSettings {
  lockSystemAccess: boolean;
  logoutAfterInactivity: 'never' | '5min' | '10min' | '30min' | '1hr';
  quickPay: boolean;
  productColumns: 3 | 4 | 5 | 6;
  quickLogin: boolean;
  lowStockNotif: boolean;
  lowStockEmail: boolean;
  emailPrintReceipt: boolean;
  emailReceipt: boolean;
}

@Component({
  selector: 'app-possettings',
  templateUrl: './possettings.component.html',
  styleUrls: []
})
export class PosSettingsComponent implements OnInit {
  settings: PosSettings = {
    lockSystemAccess: false,
    logoutAfterInactivity: 'never',
    quickPay: false,
    productColumns: 4,
    quickLogin: false,
    lowStockNotif: false,
    lowStockEmail: false,
    emailPrintReceipt: false,
    emailReceipt: false
  };
  response: Object;
  responsee:Object;

  constructor(private requestsService: RequestsService,public toastr: ToastsManager) {}

  ngOnInit(): void {
    this.loadSettings();
  }

 saveSettings(): void {
  const body = {
    lockSystemAccess: this.settings.lockSystemAccess,
    logoutAfterInactivity: this.settings.logoutAfterInactivity,
    quickPay: this.settings.quickPay,
    productColumns: this.settings.productColumns,
    quickLogin: this.settings.quickLogin,
    lowStockNotif: this.settings.lowStockNotif,
    lowStockEmail: this.settings.lowStockEmail,
    emailPrintReceipt: this.settings.emailPrintReceipt,
    emailReceipt: this.settings.emailReceipt
  };

  this.requestsService.postRequest('settings/updateSettingsNew', body, 'json') // Change to 'json' if multipart is unnecessary
    .subscribe(
      (response: any) => {
        this.response = response;
      },
      error => {
        console.error('Save error', error);
        this.toastr.error('Failed to save settings');
      },
      () => {
        setTimeout(() => {
          // this.fetchGeneralSetting();
        }, 500);
        this.toastr.success(this.response['message'], this.response['result_type']);
      }
    );
}


 loadSettings() {
    let generalSettingBody = new HttpParams();
    generalSettingBody = generalSettingBody.set('table', 'general_settings');
    this.requestsService.postRequest('settings/fetch', generalSettingBody).subscribe(
      (response: Response) => {
        this.responsee = response;
      }, error => {
      },
      () => {
        //set city dropdown value
        // let city_id = this.cityDropDownRef.getItemByValue(String(this.generatSetting.city));
        // this.cityDropDownRef.selectItem(city_id);

        if (this.responsee && this.responsee[0]) {
          const res = this.responsee[0]; // for readability

this.settings.lockSystemAccess = res.lockSystemAccess === '1' || res.lockSystemAccess === true;
this.settings.logoutAfterInactivity = res.logoutAfterInactivity || 'never';
this.settings.quickPay = res.quickPay === '1' || res.quickPay === true;
this.settings.productColumns = +res.productColumns as 3 | 4 | 5 | 6;

this.settings.quickLogin = res.quickLogin === '1' || res.quickLogin === true;
this.settings.lowStockNotif = res.lowStockNotif === '1' || res.lowStockNotif === true;
this.settings.lowStockEmail = res.lowStockEmail === '1' || res.lowStockEmail === true;
this.settings.emailPrintReceipt = res.emailPrintReceipt === '1' || res.emailPrintReceipt === true;
this.settings.emailReceipt = res.emailReceipt === '1' || res.emailReceipt === true;



          }
    }
    );
  }
}
